

import React, { Component } from 'react';
import _ from 'lodash'
import { decode } from 'he'
import { Table } from 'react-bootstrap'

//import { getFromDrupalAPI } from '../fetchJSON.js'

class Resources extends Component {

  constructor() {
    super();
    this.state = { otherResources: null, sermonResources: null }
  }

  render() {

    var otherResources = [{ "resourceName": "CRCK Privacy Policy", "url": "https://api.crckingston.org.au/sites/crckingston.org.au/files/guidelines/CRCK%20Privacy.pdf" },
    { "resourceName": "CRCA Public Statement on Marriage", "url": "https://api.crckingston.org.au/sites/crckingston.org.au/files/guidelines/CRCA%20PUBLIC%20STATEMENT%20ON%20MARRIAGE.PDF" },
    { "resourceName": "Direct Debit Authorisation Form", "url": "https://api.crckingston.org.au/sites/crckingston.org.au/files/guidelines/Direct%20Debit%20Form.pdf" },
    { "resourceName": "Credit Card Authorisation Form", "url": "https://api.crckingston.org.au/sites/crckingston.org.au/files/guidelines/Credit%20Card%20Authorisation%20Form.pdf" },
    { "resourceName": "Service Leader Guidelines", "url": "https://api.crckingston.org.au/sites/crckingston.org.au/files/guidelines/CRCK%20Service%20Leader%20Guidelines.pdf" },
    { "resourceName": "Network Safety & Care Policy (2018)", "url": "https://api.crckingston.org.au/sites/crckingston.org.au/files/guidelines/CRCST%20Safety%20and%20Care%20Policy%202018.pdf" }]

    /*var sermonResources = [{ "resourceName": "Work, Rest & Play CG Studies", "url": "https://api.crckingston.org.au/sites/crckingston.org.au/files/attachments/Work%20Rest%20and%20Play%20CG%20Studies.pdf" },
    { "resourceName": "God Will Have His King CG Studies", "url": "https://api.crckingston.org.au/sites/crckingston.org.au/files/attachments/1%20Samuel%20Connect%20Group%20Studies_0.pdf" }]*/


    var otherResourcesRows = _.map(otherResources, (resource) => {
      return (
        <tr key={_.uniqueId()}>
          <td>{decode(resource.resourceName)}</td>
          <td><i className="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;&nbsp;<a href={resource.url} target="_blank" rel="noopener noreferrer">{resource.resourceName}.pdf</a></td>
        </tr>
      )
    });

    /*var sermonResourcesRows = _.map(sermonResources, (resource) => {
      return (
        <tr key={_.uniqueId()}>
          <td>{decode(resource.resourceName)}</td>
          <td><i className="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;&nbsp;<a href={resource.url} target="_blank" rel="noopener noreferrer">{resource.resourceName}.pdf</a></td>
        </tr>
      )
    });*/
    var otherResourcesTable;
    if (otherResources) {
      otherResourcesTable = (
        <Table responsive striped bordered condensed hover>
          <tbody>
            {otherResourcesRows}
          </tbody>
        </Table>
      );
    }
    else {
      otherResourcesTable = <div>Loading Resources...</div>
    }

    /*var sermonResourcesTable;
    if (sermonResources) {
      sermonResourcesTable = (
        <Table responsive striped bordered condensed hover>
          <tbody>
            {sermonResourcesRows}
          </tbody>
        </Table>
      );
    }
    else {
      sermonResourcesTable = <div>Loading Sermon Resources...</div>
    }*/

    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Resources</h1>
          </div>
        </header>

        <section className="container">

          {otherResourcesTable}
          {/*<p className="lead">Sermon Resources</p>
          {sermonResourcesTable}
          */}
          <br/>
          <h3>Shaping Kingston - by Kees Wierenga</h3>
          <ul>
            <li>The story of God's children in Kingston, especially focussing on the Reformed Church. Includes references to St Aloysius (Catholic), St Clements (Anglican) and St Johns (Presbyterian) and how the churches and their leaders all worked together.</li>
            <li>A4 format, 8 chapters + bibliography - 149 pages, 61 photos, 617 references</li>
            <li>Please see <a href="https://api.crckingston.org.au/sites/crckingston.org.au/files/CRCK%20book%20-%20cover%20f%20%26%20b%2C%20colour.pdf">the cover</a> for independent reviews</li>
            <li>$40 plus postage ($9 per each or $10 per 2 to the same address, within Australia)</li>
            <li>To order or for more information contact <a href="mailto:iwiereng@utas.edu.au">iwiereng@utas.edu.au</a></li>
          </ul>
          
        </section>
      </section>
    );
  }
}

export default Resources;
